import React, { useEffect, useState } from 'react';
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Swal from 'sweetalert2';
import axios from 'axios';
import ImageNotFound from '../../assets/images/not-found.png';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const PageAbout = () => {
    const [loading, setLoading] = useState(false);
    const [page_about_id, setPageAboutId] = useState(1);
    const [about_title, setAboutTitle] = useState('');
    const [about_sub_title, setAboutSubTitle] = useState('');
    const [about_description, setAboutDescription] = useState('');
    const [about_indicator_icon_trip, setAboutIndicatorIconTrip] = useState('');
    const [about_indicator_text_trip, setAboutIndicatorTextTrip] = useState('');
    const [about_indicator_icon_package, setAboutIndicatorIconPackage] = useState('');
    const [about_indicator_text_package, setAboutIndicatorTextPackage] = useState('');
    const [about_indicator_icon_unit, setAboutIndicatorIconUnit] = useState('');
    const [about_indicator_text_unit, setAboutIndicatorTextUnit] = useState('');
    const [about_image, setAboutImage] = useState('');
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;
    const URLZFILES = process.env.REACT_APP_API_ZFILES;

    useEffect(() => {
        window.scrollTo(0, 0);
        getAbout();
    }, []);

    const getAbout = async () => {
        setLoading(true);
        await axios.get(ENDPOINT + 'get-page-about/' + page_about_id)
        .then(response => {
            setLoading(false);
            setPageAboutId(response.data.data.page_about_id)
            setAboutTitle(response.data.data.about_title);
            setAboutSubTitle(response.data.data.about_sub_title);
            setAboutDescription(response.data.data.about_description);
            setAboutIndicatorIconTrip(response.data.data.about_indicator_icon_trip);
            setAboutIndicatorTextTrip(response.data.data.about_indicator_text_trip);
            setAboutIndicatorIconPackage(response.data.data.about_indicator_icon_package);
            setAboutIndicatorTextPackage(response.data.data.about_indicator_text_package);
            setAboutIndicatorIconUnit(response.data.data.about_indicator_icon_unit);
            setAboutIndicatorTextUnit(response.data.data.about_indicator_text_unit);
            setAboutImage(response.data.data.about_image);
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await axios
        .put(ENDPOINT + "update-page-about/" + page_about_id, {
            about_title: about_title,
            about_sub_title: about_sub_title,
            about_description: about_description,
            about_indicator_icon_trip: about_indicator_icon_trip,
            about_indicator_text_trip: about_indicator_text_trip,
            about_indicator_icon_package: about_indicator_icon_package,
            about_indicator_text_package: about_indicator_text_package,
            about_indicator_icon_unit: about_indicator_icon_unit,
            about_indicator_text_unit: about_indicator_text_unit,
            about_image: about_image
        })
        .then((response) => {
            setLoading(false);
            getAbout();
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        })
        .catch(function (error) {
            console.log(error);
            setLoading(true);
            Swal.fire({
                icon: "error",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                timer: 3000,
                html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        });
    };

    const handleFileChange = async (e) => {
        setLoading(true);
        const form = new FormData();
        form.append('file', e.target.files[0]);
        form.append('destination', 'zfiles/about/');
        await axios.post(ENDPOINT + 'upload-page-about', form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            setAboutImage(response.data.data.pathFile);
            setLoading(false);
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 1000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const handleFileChangeIcon1 = async (e) => {
        setLoading(true);
        const form = new FormData();
        form.append('file', e.target.files[0]);
        form.append('destination', 'zfiles/about/');
        await axios.post(ENDPOINT + 'upload-page-about', form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            setAboutIndicatorIconTrip(response.data.data.pathFile);
            setLoading(false);
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 1000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const handleFileChangeIcon2 = async (e) => {
        setLoading(true);
        const form = new FormData();
        form.append('file', e.target.files[0]);
        form.append('destination', 'zfiles/about/');
        await axios.post(ENDPOINT + 'upload-page-about', form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            setAboutIndicatorIconPackage(response.data.data.pathFile);
            setLoading(false);
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 1000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const handleFileChangeIcon3 = async (e) => {
        setLoading(true);
        const form = new FormData();
        form.append('file', e.target.files[0]);
        form.append('destination', 'zfiles/about/');
        await axios.post(ENDPOINT + 'upload-page-about', form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            setAboutIndicatorIconUnit(response.data.data.pathFile);
            setLoading(false);
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 1000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline','strike', 'blockquote'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            ['link', 'image'],
            ['clean']
        ],
    };
    
    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ];

    return (
        <>
            <ContentHeader title="Sobre Nosotros" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-about-card">
                            <div className="page-about-card-header">
                                <h3 className="page-about-title">
                                    <i className="fas fa-cog"></i>
                                    Gestionar Información
                                </h3>
                                <p className="page-about-description">
                                    En esta sección, puedes gestionar la información sobre nosotros, incluyendo el título, subtítulo, descripción, indicadores y la imagen principal.
                                </p>
                            </div>
                            <div className="page-about-card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="page-about-section">
                                        <div className="page-about-section-header">
                                            <h4 className="page-about-section-title">Información Principal</h4>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="page-about-form-group">
                                                    <label className="page-about-label">
                                                        Título<span className="page-about-required">*</span>
                                                    </label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control form-control-sm" 
                                                        value={about_title} 
                                                        onChange={(e) => setAboutTitle(e.target.value)} 
                                                        required
                                                    />
                                                    <span className="page-about-field-hint">Ingrese el título principal</span>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="page-about-form-group">
                                                    <label className="page-about-label">
                                                        Subtítulo<span className="page-about-required">*</span>
                                                    </label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control form-control-sm" 
                                                        value={about_sub_title} 
                                                        onChange={(e) => setAboutSubTitle(e.target.value)} 
                                                        required
                                                    />
                                                    <span className="page-about-field-hint">Ingrese el subtítulo</span>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="page-about-form-group">
                                                    <label className="page-about-label">
                                                        Descripción<span className="page-about-required">*</span>
                                                    </label>
                                                    <div className="page-about-editor-wrapper">
                                                        <ReactQuill 
                                                            value={about_description} 
                                                            onChange={setAboutDescription}
                                                            modules={modules}
                                                            formats={formats}
                                                            className="page-about-editor"
                                                        />
                                                    </div>
                                                    <span className="page-about-field-hint">Ingrese la descripción detallada</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="page-about-section">
                                        <div className="page-about-section-header">
                                            <h4 className="page-about-section-title">Indicadores</h4>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="page-about-indicator-card">
                                                    <h5 className="page-about-indicator-title">Indicador de Viaje</h5>
                                                    <div className="page-about-indicator-content">
                                                        <div className="page-about-image-preview">
                                                            {about_indicator_icon_trip && (
                                                                <img src={URLZFILES + about_indicator_icon_trip} 
                                                                     alt="Viaje" 
                                                                     className="page-about-preview-img" />
                                                            )}
                                                        </div>
                                                        <label className="page-about-upload-label">
                                                            <i className="fas fa-upload"></i>
                                                            Seleccionar Icono
                                                            <input 
                                                                type="file" 
                                                                className="page-about-upload-input form-control-sm" 
                                                                onChange={handleFileChangeIcon1} 
                                                            />
                                                        </label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control form-control-sm" 
                                                            value={about_indicator_text_trip} 
                                                            onChange={(e) => setAboutIndicatorTextTrip(e.target.value)} 
                                                            placeholder="Texto del indicador"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="page-about-indicator-card">
                                                    <h5 className="page-about-indicator-title">Indicador de Paquete</h5>
                                                    <div className="page-about-indicator-content">
                                                        <div className="page-about-image-preview">
                                                            {about_indicator_icon_package && (
                                                                <img src={URLZFILES + about_indicator_icon_package} 
                                                                     alt="Paquete" 
                                                                     className="page-about-preview-img" />
                                                            )}
                                                        </div>
                                                        <label className="page-about-upload-label">
                                                            <i className="fas fa-upload"></i>
                                                            Seleccionar Icono
                                                            <input 
                                                                type="file" 
                                                                className="page-about-upload-input form-control-sm" 
                                                                onChange={handleFileChangeIcon2} 
                                                            />
                                                        </label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control form-control-sm" 
                                                            value={about_indicator_text_package} 
                                                            onChange={(e) => setAboutIndicatorTextPackage(e.target.value)} 
                                                            placeholder="Texto del indicador"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="page-about-indicator-card">
                                                    <h5 className="page-about-indicator-title">Indicador de Unidad</h5>
                                                    <div className="page-about-indicator-content">
                                                        <div className="page-about-image-preview">
                                                            {about_indicator_icon_unit && (
                                                                <img src={URLZFILES + about_indicator_icon_unit} 
                                                                     alt="Unidad" 
                                                                     className="page-about-preview-img" />
                                                            )}
                                                        </div>
                                                        <label className="page-about-upload-label">
                                                            <i className="fas fa-upload"></i>
                                                            Seleccionar Icono
                                                            <input 
                                                                type="file" 
                                                                className="page-about-upload-input form-control-sm" 
                                                                onChange={handleFileChangeIcon3} 
                                                            />
                                                        </label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control form-control-sm" 
                                                            value={about_indicator_text_unit} 
                                                            onChange={(e) => setAboutIndicatorTextUnit(e.target.value)} 
                                                            placeholder="Texto del indicador"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="page-about-section">
                                        <div className="page-about-section-header">
                                            <h4 className="page-about-section-title">Imagen Principal</h4>
                                        </div>
                                        <div className="page-about-main-image">
                                            <div className="page-about-image-preview">
                                                {about_image ? (
                                                    <img src={URLZFILES + about_image} 
                                                         alt="Principal" 
                                                         className="page-about-preview-img" />
                                                ) : (
                                                    <img src={ImageNotFound} 
                                                         alt="No imagen" 
                                                         className="page-about-preview-img" />
                                                )}
                                            </div>
                                            <label className="page-about-upload-label">
                                                <i className="fas fa-upload"></i>
                                                Seleccionar Imagen
                                                <input 
                                                    type="file" 
                                                    className="page-about-upload-input form-control-sm" 
                                                    onChange={handleFileChange} 
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="page-about-form-actions">
                                        <button type="submit" className="btn btn-success">
                                            <i className="fas fa-save"></i> Guardar Cambios
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading && <Loader />}
        </>
    );
};

export default PageAbout;